import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ChangeCompanyModal from "../../components/Navbar/components/ChangeCompanyModal";
import useModal from "../../hooks/useModal";
import DashboardStatusPanel from "../../components/DashboardStatusPanel/DashboardStatusPanel";
import ShadowBox from "../../components/ShadowBox/ShadowBox";
import { useStore } from "../../store/useStore";
import LastMacroMap from "./Map/LastMacroMap";
import Tabs from "../../components/Tabs/Tabs";
import Tab from "../../components/Tabs/Components/Tab";
import TabPanel from "../../components/Tabs/Components/TabPanel";
import { Brodcast, Flag2, Map1, People } from "iconsax-react";
import JourneyControlGeneral from "../JourneyControl/Components/JourneyControlGeneral";

const Dashboard: React.FC<{}> = () => {
  const location = useLocation();
  const { pushModal } = useModal();
  const charts = useStore((state) => state.dashboard.charts);
  const [tab, setTab] = useState<number>(0);
  // const getFleetEvolution = useStore(
  //   (state) => state.dashboard.getFleetEvolution
  // );
  // const getTimeAggregator = useStore(
  //   (state) => state.dashboard.getTimeAggregator
  // );
  const getLastMacroPositions = useStore(
    (state) => state.dashboard.getLastMacroPositions
  );
  // const getMacroAlterations = useStore(
  //   (state) => state.dashboard.getMacroAlterations
  // );
  // const isLoadingFleetEvoluition = useStore(
  //   (state) => state.dashboard.isLoadingFleetEvoluition
  // );
  // const isLoadingTimeAggregator = useStore(
  //   (state) => state.dashboard.isLoadingTimeAggregator
  // );
  const isLoadingLastMacroPositions = useStore(
    (state) => state.dashboard.isLoadingLastMacroPositions
  );
  // const isLoadingMacroAlterations = useStore(
  //   (state) => state.dashboard.isLoadingMacroAlterations
  // );

  useEffect(() => {
    if (location?.state?.openChangeCompanyModal) {
      pushModal(<ChangeCompanyModal notClosable />);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // getFleetEvolution();
    // getTimeAggregator();
    getLastMacroPositions();
    // getMacroAlterations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Tabs tab={tab} setTab={setTab}>
        <Tab label="Controle em tempo real" icon={<Brodcast variant="Bulk" />} />
        <Tab label="Mapa de colaboradores" icon={<Map1 variant="Bulk" />} />
      </Tabs>
      <TabPanel tab={tab} index={0}>
        <DashboardStatusPanel />
      </TabPanel>
      <TabPanel tab={tab} index={1}>
        <div className="mt-4">
            <ShadowBox>
              <LastMacroMap
                data={charts.data.lastMacroPositions}
                loading={isLoadingLastMacroPositions}
              />
            </ShadowBox>
          </div>
      </TabPanel>



    {/*
      <Tabs tab={tab} setTab={setTab}>
        <Tab label="Controle em tempo real" icon={<Brodcast variant="Bulk" />} />
        <Tab label="Controle de jornada" icon={<Flag2 variant="Bulk" />} />
        <Tab label="Mapa de colaboradores" icon={<Map1 variant="Bulk" />} />
      </Tabs>
      <TabPanel tab={tab} index={0}>
        <DashboardStatusPanel />
      </TabPanel>
      <TabPanel tab={tab} index={1}>
        <JourneyControlGeneral />
      </TabPanel>
      <TabPanel tab={tab} index={2}>
        <div className="mt-4">
            <ShadowBox>
              <LastMacroMap
                data={charts.data.lastMacroPositions}
                loading={isLoadingLastMacroPositions}
              />
            </ShadowBox>
          </div>
      </TabPanel>
    */}

    

    </>
  );
};

export default Dashboard;
